/**
 * Chatwoot config response parser
 *
 * Normalizes `getChatwootConfig` callable JSON (`baseUrl` / `baseURL`, inbox id, tokens).
 */

import { ChatwootWidgetRuntimeConfig } from '@physiofit-digital/physiofit_types';

/**
 * Parses raw callable JSON into `ChatwootWidgetRuntimeConfig`.
 *
 * @param {Object} data Raw `getChatwootConfig` response object.
 * @return {Object | null} Widget config or null when required fields are missing.
 */
export function parseGetChatwootConfigResponse(data: Record<string, unknown>): ChatwootWidgetRuntimeConfig | null {
  if (data.error != null) return null;

  const websiteToken = data.websiteToken;
  const baseUrlRaw =
    (typeof data.baseUrl === 'string' ? data.baseUrl : null) ??
    (typeof data.baseURL === 'string' ? data.baseURL : null);

  if (typeof websiteToken !== 'string' || !websiteToken.trim()) {
    return null;
  }
  if (typeof baseUrlRaw !== 'string' || !baseUrlRaw.trim()) {
    return null;
  }

  const baseUrl = baseUrlRaw.trim();

  const product = typeof data.product === 'string' ? data.product : undefined;
  let inboxId: number | undefined;
  if (typeof data.inboxId === 'number' && Number.isFinite(data.inboxId)) {
    inboxId = data.inboxId;
  } else if (typeof data.inboxId === 'string' && data.inboxId.trim() !== '') {
    const n = Number(data.inboxId);
    if (Number.isFinite(n)) inboxId = n;
  }

  return {
    baseUrl,
    websiteToken: websiteToken.trim(),
    product,
    portalSlug: typeof data.portalSlug === 'string' ? data.portalSlug : undefined,
    inboxId,
    widgetSettings:
      data.widgetSettings && typeof data.widgetSettings === 'object'
        ? (data.widgetSettings as ChatwootWidgetRuntimeConfig['widgetSettings'])
        : undefined,
    version: typeof data.version === 'string' ? data.version : undefined,
  };
}
